/**
 * 懒加载 Pannellum（CDN），播放器与热点放置共用
 */
export function loadPannellum() {
  return new Promise((resolve, reject) => {
    if (window.pannellum) {
      resolve(window.pannellum);
      return;
    }
    if (!document.getElementById('zhxt-pannellum-css')) {
      const link = document.createElement('link');
      link.id = 'zhxt-pannellum-css';
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/pannellum.css';
      document.head.appendChild(link);
    }
    const existed = document.getElementById('zhxt-pannellum-js');
    if (existed) {
      if (window.pannellum) {
        resolve(window.pannellum);
        return;
      }
      existed.addEventListener('load', () => resolve(window.pannellum));
      existed.addEventListener('error', reject);
      return;
    }
    const script = document.createElement('script');
    script.id = 'zhxt-pannellum-js';
    script.src = 'https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/pannellum.js';
    script.onload = () => resolve(window.pannellum);
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

/** 全景图地址附带登录 token（走 A 代理读图） */
export function authPanoramaImageUrl(path) {
  if (!path) return '';
  const token = localStorage.getItem('token') || '';
  const join = path.includes('?') ? '&' : '?';
  return `${path}${join}access_token=${encodeURIComponent(token)}`;
}

export function destroyPannellumViewer(viewerRef) {
  if (!viewerRef?.current) return;
  try { viewerRef.current.destroy(); } catch (_) { /* ignore */ }
  viewerRef.current = null;
}
